/** DOM event fired when socket receives visiting_card_updated (owner changed card settings). */
export const VISITING_CARD_UPDATED_EVENT = 'catalogofworks:visiting-card-updated';

export function dispatchVisitingCardUpdated(): void {
  window.dispatchEvent(new CustomEvent(VISITING_CARD_UPDATED_EVENT));
}
